<template>
  <transition name="fade">
    <div v-if="visible" class="modal session-modal">
      <div class="overlay" @click="handleClose"></div>
      <div class="wrapper">
        <div class="container">
          <div class="form">
            <div class="form-wrapper">
              <div class="locked-account-popup">
                <div class="lock-icon">🔒</div>
                <div class="lock-title">{{ $t("Session Expired") }}</div>
                <div class="lock-message">
                  {{
                    $t(
                      "Your session has expired due to inactivity. Please log in again to continue."
                    )
                  }}
                </div>
                <button class="button" @click="handleClose">
                  {{ $t("OK") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "SessionTimeoutModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal {
  line-height: 1;
}

.lock-icon {
  font-size: 48px;
  margin-bottom: 16px;
  text-align: center;
}

.lock-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 12px;
  width: 100%;
  text-align: center;
}

.lock-message {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 24px;
  width: 100%;
  text-align: center;
}
</style>
